import React, { useEffect } from 'react'
import { RouteComponentProps } from 'react-router-dom'
import { MatchParams } from '../types'
import { getAccessToken } from '../../lib/api/subscriber'
import SubscriberFieldset from '../../components/Form/SubscriberFieldset'
import PaymentInfoFieldset from '../../components/Payment/PaymentInfoFieldset'
import useSubscribers from '../../hooks/useSubscribers'
import PaymentStatusFieldSet from '../../components/Payment/PaymentStatusFieldset'
import { Helmet } from 'react-helmet'
import useLists from '../../hooks/useLists'
import useSubscriptions from '../../hooks/useSubscriptions'
import querystring from 'query-string'


function SubscribersPage (props:RouteComponentProps<MatchParams>) {
  const { getSubscribersInfoData, subscribersInfo }  = useSubscribers()
  const { getListsInfoData, listsInfo } = useLists()
  const { getSubscriptionsInfoData, subscriptionsInfo } = useSubscriptions() 
  // const [ denyUrl, setDenyUrl] = useState('')
  const { email, listId } = props.match.params
  const { history } = props
  // const [ emailId, setEmailId ] = useState(email)
  // const tokenUrl = window.location.href.split('?')[1]
  const token = querystring.parseUrl(window.location.href).query.token
  const errorCode = querystring.parseUrl(window.location.href).query.errorCode

  useEffect(()=>{
    if(token){
      getAccessToken({listId:listId,subscriber:(subscribersInfo.status === 'success' && email !== subscribersInfo.data.email)?subscribersInfo.data.email:email,query:"token="+token}).then(res=>
        {
          localStorage.setItem(
            'userInfo',
            JSON.stringify(
              {
                token: res.data.accessToken
              }
            )
          )
          //token 인증 후, 구독폼, 구독자 정보 요청
          if(email){
            getListsInfoData(listId)
            getSubscriptionsInfoData(listId)
            getSubscribersInfoData({listId:listId,subscriber:email})
          }
        }
      ).catch((e)=>{
        //토큰 인증 실패한 경우, redirect
        history.push({
          pathname:`/subscribers/auth/${listId}`,
          search: `?email=${email}`,
          state: { detail: e.response.data.Code }
        })
      })
    }else{
      //token url로 들어오지 않은 경우 redirect
      history.push({
        pathname:`/subscribers/auth/${listId}`,
        search: `?email=${email}`,
        state: { detail: 'tokenError' }
      })
    }
    

  },[])

  useEffect(()=>{
    if(subscribersInfo.status === 'failure'){
      //에러 코드에 따른 메세지 분기
      if(subscribersInfo.errorData?.response?.data.Code === 'Errors.List.NotExistEmail') {
        history.push({
          pathname:`/subscribers/auth/${listId}`,
          search: `?email=${email}`,
          state: { detail: 'Errors.List.NotExistEmail'}
        })
      }else if(subscribersInfo.errorData?.response?.data.Code === 'Errors.List.EditUnsubscribedSubscriber'){
        history.push({
          pathname:`/subscribers/auth/${listId}`,
          search: `?email=${email}`,
          state: { dtail: 'Errors.List.EditUnsubscribedSubscriber'}
        })
      }
    }else if(subscribersInfo.status === 'success'){
      if(subscribersInfo.data.status === 'D' || subscribersInfo.data.status === 'A'){
        history.push({
          pathname:`/subscribers/auth/${listId}`,
          search: `?email=${email}`,
          state: { detail: 'Errors.List.EditUnsubscribedSubscriber'}
        })
      }
    }
  },[subscribersInfo])

  const changeEmailInUrl = () =>{
    history.replace({
      pathname:`/subscribers/modify/${listId}/${subscribersInfo.data.email}?${"token="+token}`,
    })
  }

  return (
    <>
    <Helmet>
      <title>{listsInfo.data.listName} 구독 정보 변경하기</title>
    </Helmet>
      <div className="form-frame-subscriber">
        <div className="inner">
          <div id="stb_subscriber">
            <div className="stb_subscriber_header">
              <h1>{listsInfo.data.listName}<br/>구독 정보 변경하기</h1>
            </div>
            <div className="stb_form">
              <div className="stb_subscriber_field">
              {subscribersInfo.data?.fields?.filter(res=>(res.substitution==='email'
                )).map(res=>{
                  return <SubscriberFieldset key={res.substitution} field={res} listId={listId} changeEmailInUrl={changeEmailInUrl} oldEmail={email}/>
                })
                }
              </div>
              
              {subscriptionsInfo.data.varsSettings.filter(item=>item.show).length > 1 &&
              <div className="stb_subscriber_field">
                {subscribersInfo.data?.fields?.filter(res=>(res.substitution!=='email' && subscriptionsInfo.data.varsSettings.filter(e=>e.substitution===res.substitution)[0]?.show
                ))
                .map(res=>{
                  return <SubscriberFieldset key={res.substitution} field={res} listId={listId} changeEmailInUrl={changeEmailInUrl}/>
                })
                }
              </div>
              }

              {listsInfo.data.isPaidList && 
              <>
                <div className="stb_subscriber_field">
                  <PaymentStatusFieldSet listId={listId} email={email} errorCode={errorCode} />
                </div>

                <div className="stb_subscriber_field">
                  <PaymentInfoFieldset listId={listId} email={email} errorCode={errorCode}/>
                </div>
              </>
              }

            </div>
            <div className="stb_subscriber_footer">
              <p>더 이상 뉴스레터를 받고 싶지 않다면? <a href={subscribersInfo.data.denyUrl}>수신거부</a></p>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default SubscribersPage